import { DiagnosticLauncherPosition } from './types';

export interface DiagnosticLauncherBoundsInput {
  viewportWidth: number;
  viewportHeight: number;
  launcherWidth: number;
  launcherHeight: number;
  insetTop?: number;
  insetRight?: number;
  insetBottom?: number;
  insetLeft?: number;
  edgeMargin?: number;
}

export const getDefaultDiagnosticLauncherPosition = ({
  viewportHeight,
  launcherHeight,
  insetBottom = 0,
  insetLeft = 0,
  edgeMargin = 12,
}: DiagnosticLauncherBoundsInput): DiagnosticLauncherPosition => ({
  x: insetLeft + edgeMargin,
  y: Math.max(edgeMargin, viewportHeight - insetBottom - launcherHeight - edgeMargin),
});

export const clampDiagnosticLauncherPosition = (
  position: DiagnosticLauncherPosition,
  {
    viewportWidth,
    viewportHeight,
    launcherWidth,
    launcherHeight,
    insetTop = 0,
    insetRight = 0,
    insetBottom = 0,
    insetLeft = 0,
    edgeMargin = 12,
  }: DiagnosticLauncherBoundsInput
): DiagnosticLauncherPosition => {
  const minX = insetLeft + edgeMargin;
  const minY = insetTop + edgeMargin;
  const maxX = Math.max(minX, viewportWidth - insetRight - launcherWidth - edgeMargin);
  const maxY = Math.max(minY, viewportHeight - insetBottom - launcherHeight - edgeMargin);
  return {
    x: Math.min(maxX, Math.max(minX, position.x)),
    y: Math.min(maxY, Math.max(minY, position.y)),
  };
};

export const isDiagnosticDrag = (dx: number, dy: number, threshold = 6): boolean =>
  Math.hypot(dx, dy) >= threshold;
